import React from "react";
import ReactDOM from "react-dom";
import Routes from "./Router";

ReactDOM.render(<Routes />, document.getElementById("root"));
